<div *ngIf="email">
    <div class="row">
        <div class="column">Date sent: {{email?.sentDate | date: 'short'}}</div>
    </div>
    <div class="row">
        <div class="column">From: {{email?.from}}</div>
    </div>
    <div class="row">
        <div class="column">To: {{email?.to}}</div>
    </div>
    <div class="row">
        <div class="column">CC: {{email?.cc}}</div>
    </div>
    <div *ngIf="mayViewBcc" class="row">
        <div class="column">BCC: {{email?.bcc}}</div>
    </div>
    <div class="row">
        <div class="column">Subject: {{email?.subject}}</div>
    </div>
    <div class="row">
        <div class="column">Template: {{email?.template}}</div>
    </div>
    <hr class="divider"/>
    <div class="row">
        <div class="column">
            <app-render-html [html]="email?.text" [css]="'padding-md'"></app-render-html>
        </div>
    </div>
    <div *ngIf="email?.attachments?.length">
        <hr class="divider"/>
        <div class="text-large">Attachments</div>
        <mat-card>
            <mat-card-content *ngFor="let attach of email.attachments">
                {{attach.name}}
                <button
                        type="button"
                        mat-icon-button
                        [matTooltip]="'Click to download this attachment'"
                        [disabled]="loading"
                        [color]="'primary'"
                        (click)="downloadAttachment(attach)">
                    <mat-icon>download</mat-icon></button>
            </mat-card-content>
        </mat-card>
    </div>
    <app-button-list>
        <app-button *ngIf="mayResend" [loading]="loading" (clickedEvent)="resend()">Resend </app-button>
    </app-button-list>
</div>